import {Button, Modal} from 'antd';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import PropTypes from 'prop-types';
import React, {useRef} from 'react';
import Barcode from 'react-barcode';

const LABEL_W_MM = 62;
const LABEL_H_MM = 32; // slightly taller to fit product name + barcode + number

const BarcodeGenerate = ({visible, onClose, product}) => {
  const barcodeRef = useRef();

  if (!product) {return null;}

  const handleDownloadPDF = async () => {
    const element = barcodeRef.current;

    const canvas = await html2canvas(element, {
      scale: 4,
      useCORS: true,
      backgroundColor: '#ffffff',
      logging: false,
    });

    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [LABEL_H_MM, LABEL_W_MM],
    });

    pdf.addImage(imgData, 'PNG', 0, 0, LABEL_W_MM, LABEL_H_MM);

    pdf.save(`${product.productName ?? 'barcode'}-label.pdf`);
  };

  return (
    <Modal
      title={'Barcode Label'}
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={420}
    >
      <div className={'flex flex-col items-center w-full'}>

        {/* Label area  */}
        <div
          ref={barcodeRef}
          className={'bg-white w-full flex flex-col items-center justify-center py-2 px-4'}
          style={{maxWidth: 360}}
        >
          {/* Product name — centered, bold, never clipped */}
          <p className={'w-full text-center font-bold text-xs tracking-wide text-black mb-1'}>
            {product.productName ?? ''}
          </p>

          {/* Barcode */}
          <div className={'flex justify-center w-full'}>
            <Barcode
              value={product.eanCode || '000000000000'}
              width={2}
              height={50}
              fontSize={11}
              margin={0}
              displayValue={true}
              background={'#ffffff'}
              lineColor={'#000000'}
            />
          </div>

          <div className={'flex items-center w-full mt-2'} style={{maxWidth: 360}}>
            <div className={'flex-1 border-t-2 border-dashed border-gray'} />
            {/* <span className={'text-gray text-xs mx-2 select-none'}>✂</span> */}
            <div className={'flex-1 border-t-2 border-dashed border-gray'} />
          </div>
        </div>

      </div>

      <div className={'flex justify-center mt-5'}>
        <Button className={'btn-secondary'} onClick={handleDownloadPDF}>
          Download Label PDF
        </Button>
      </div>
    </Modal>
  );
};

BarcodeGenerate.propTypes = {
  visible:  PropTypes.bool.isRequired,
  onClose:  PropTypes.func.isRequired,
  product:  PropTypes.shape({
    productName: PropTypes.string,
    eanCode:     PropTypes.string,
  }),
};

export default BarcodeGenerate;
